import request from '@/utils/request'

export function login(username, password,uid) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password,
      uid
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js